import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import { catchError, map, switchMap } from 'rxjs/operators';
import { IEffect } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effect.interface';
import {
  LoadJobsiteExperience,
  LoadJobsiteExperienceComplete,
  LoadJobsiteExperienceFail,
  LS_LOAD_EXPERIENCE,
} from '../actions/jobsite-actions/jobsite.actions';
import { ExperiencesResponse, ExperiencesService } from '@cemex-core/cmx-api';
import { ModifyFeatureState } from '@ordersnproducts/modules/new-modify-order/reducers';
import { LoadNextWorkingDayModifyActionV5 } from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/actions/next-working-day.actions';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';

@Injectable()
export class JobsiteLoadExperienceModifyEffects implements IEffect {
  /**
   * Monitors the actions$ Actions stream (it's a sub-type of Observable) for
   * LS_LOAD_EXPERIENCE events; then attempts to get a jobsite's experience as
   * an ExperiencesResponse object from the injected ExperiencesService; and finally
   * handles success or failure when getting the experience details.
   * @type {Observable<LoadJobsiteExperienceComplete | LoadJobsiteExperienceFail>} the result of the address-loading operation
   */

  JobsiteLoadExperienceModify$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_LOAD_EXPERIENCE),
      switchMap((payload: LoadJobsiteExperience) => {
        const request = payload.payload;
        return this.experienceService.getExperiences(request).pipe(
          map((experienceResponse: ExperiencesResponse) => {
            this.store.dispatch(new LoadJobsiteExperienceComplete(experienceResponse));
            return new LoadNextWorkingDayModifyActionV5({
              productLineCode: request.productTypeCode,
              countryCode: request.countryCode,
              jobsiteCode: request.jobsiteCode,
            });
          }),
          catchError((error) => {
            const loadJobsiteExperienceComplete = {
              _links: [],
              experiences: [
                {
                  _links: [],
                  experienceId: 1,
                  isOnline: 0,
                  experienceCode: ORDER_EXPERIENCES.REQUEST,
                },
              ],
            };
            this.store.dispatch(new LoadJobsiteExperienceComplete(loadJobsiteExperienceComplete));
            return of(new LoadJobsiteExperienceFail(error));
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private experienceService: ExperiencesService,
    private store: Store<ModifyFeatureState>,
  ) {}
}
